const BASE_CONFIG = {
  defaultTimeout:15000,
  sports: {
    "0": "ke",
    "1": "ug",
    "2": "ng",
    "4": "gh",
    "5": "tz"
  },
  version: "1.0.0",
  isLocal() {
    var host = window.location.host;
    var locals = ["localhost", "0.0.0", "127.0", "192."];
    for (var i = 0; i < locals.length; i++) {
      if (host.indexOf(locals[i]) != -1) {
        return true;
      }
    }
    return false;
  },
  getApiKey: function() {
    if (!window.apiKey) {
      var keys = [
        { key: "pre", data: ["pre-"] }, // 预发布环境
        { key: "bangbet", data: ["bangbet."] }, // 线上地址
        { key: "bangbess", data: ["bangbess."] }, // 线上地址
        { key: "betsure", data: ["betsure."] },
        { key: "gbank", data: [".hw."] }, // gbank 测试服fdsfsfsd
        { key: "test1", data: ["test1."] }, // 新增test1测试服
        { key: "test2", data: ["test2."] }, // 新增test2测试服
        { key: "test3", data: ["test3."] }, // 新增test3测试服
        { key: "test4", data: ["test4."] } // 新增test4测试服
      ];
      if (this.isLocal()) {
        window.apiKey = "gbank";
      }
      if (!window.apiKey) {
        var host = window.location.host;
        for (var i in keys) {
          var tmpArr = keys[i]["data"];
          for (var k = 0; k < tmpArr.length; k++) {
            if (host.indexOf(tmpArr[k]) != -1) {
              window.apiKey = keys[i]["key"];
              break;
            }
          }
          if (window.apiKey) break;
        }
        !window.apiKey && (window.apiKey = "bangbet");
      }
    }
    return window.apiKey;
  },
  betApi: function() {
    let apis = {
      pre: "https://pre-bet-api.bangbet.com",
      bangbet: "https://bet-api.bangbet.com",
      bangbess: "https://bet-api.bangbet.com",
      betsure: "https://bet-api.betsure.com",
      gbank: "https://bet-api.hw.luckygames.team",
      test1: "https://bet-api.test1.luckygames.team",
      test2: "https://bet-api.test2.luckygames.team",
      test3: "https://bet-api.test3.luckygames.team",
      test4: "https://bet-api.test4.luckygames.team"
    };
    let apiKey = this.getApiKey();
    let currApi = apis[apiKey];
    !currApi && (currApi = apis["bangbet"]);
    return currApi; //基础API
  },
  casinoApi: function() {
    let apis = {
      pre: "https://pre-casino-api.bangbet.com",
      bangbet: "https://casino-api.bangbet.com",
      bangbess: "https://casino-api.bangbet.com",
      betsure: "https://casino-api.betsure.com",
      gbank: "https://casino-api.hw.luckygames.team",
      test1: "https://casino-api.test1.luckygames.team",
      test2: "https://casino-api.test2.luckygames.team",
      test3: "https://casino-api.test3.luckygames.team",
      test4: "https://casino-api.test4.luckygames.team"
    };
    let apiKey = this.getApiKey();
    let currApi = apis[apiKey];
    !currApi && (currApi = apis["bangbet"]);

    return currApi; // 基础API
  },
  miniUrl: function() {
    let apis = {
      pre: "https://pre-minigame-apic.bangbet.com",
      bangbet: "https://minigame-apic.bangbet.com",
      bangbess: "https://minigame-apic.bangbet.com",
      betsure: "https://minigame-apic.betsure.com",
      gbank: "https://minigame-api.hw.luckygames.team",
      test1: "https://minigame-api.test1.luckygames.team",
      test2: "https://minigame-api.test2.luckygames.team",
      test3: "https://minigame-api.test3.luckygames.team",
      test4: "https://minigame-api.test4.luckygames.team"
    };
    let apiKey = this.getApiKey();
    let currApi = apis[apiKey];
    !currApi && (currApi = apis["bangbet"]);
    return currApi; // 基础API
  },
  miniSocket: function() {
    let apis = {
      pre: "wss://pre-socket.bangbet.com",
      bangbet: "wss://socket.bangbet.com",
      bangbess: "wss://socket.bangbet.com",
      betsure: "wss://casino-socket.betsure.com",
      gbank: "wss://casino-socket.hw.luckygames.team",
      test1: "wss://casino-socket.test1.luckygames.team",
      test2: "wss://casino-socket.test2.luckygames.team",
      test3: "wss://casino-socket.test3.luckygames.team",
      test4: "wss://casino-socket.test4.luckygames.team"
    };
    let apiKey = this.getApiKey();
    let currApi = apis[apiKey];
    !currApi && (currApi = apis["bangbet"]);
    return currApi; //基础API
  },
  defaultCountry: "ke",
  countryList: [
    {
      key: "ke",
      code: "254",
      name: "Kenya",
      img: "ke.jpg",
      isShow: true,
      alpha: "K",
      isPhoneNick: true
    },
    {
      key: "ug",
      code: "256",
      name: "Uganda",
      img: "ug.jpg",
      isShow: true,
      alpha: "U",
      isPhoneNick: true
    },
    {
      key: "ng",
      code: "234",
      name: "Nigeria",
      img: "ng.png",
      isShow: true,
      alpha: "N",
      isPhoneNick: true
    },
    {
      key: "in",
      code: "91",
      name: "India",
      img: "in.jpg",
      isShow: false,
      alpha: "I",
      isPhoneNick: false
    },
    {
      key: "gh",
      code: "233",
      name: "Ghana",
      img: "gh.jpg",
      isShow: true,
      isDefaultDemo: false,
      isPhoneNick: true
    },
    {
      key: "tz",
      code: "255",
      name: "Tanzania",
      img: "gh.jpg",
      isShow: true,
      isDefaultDemo: false,
      isPhoneNick: true
    }
  ]
};

export default BASE_CONFIG;



// WEBPACK FOOTER //
// ./src/baseConfig/config.js